import Link from "next/link";
import { Zap, Heart } from "lucide-react";

const columns = [
  {
    title: "Product",
    links: [
      { href: "/features", label: "Features" },
      { href: "/pricing", label: "Pricing" },
      { href: "/how-it-works", label: "How It Works" },
      { href: "/google-review-reply-software", label: "Review Reply Software" },
      { href: "/solutions", label: "Industries" },
    ],
  },
  {
    title: "Resources",
    links: [
      { href: "/blog", label: "Blog" },
      { href: "/tools/review-response-generator", label: "Free AI Tool" },
      { href: "/tools/review-health-check", label: "Review Health Check" },
      { href: "/compare", label: "Compare" },
      { href: "/alternatives", label: "Alternatives" },
    ],
  },
  {
    title: "Legal",
    links: [
      { href: "/legal/privacy", label: "Privacy Policy" },
      { href: "/legal/terms", label: "Terms of Service" },
      { href: "/legal/sms-terms", label: "SMS Terms" },
    ],
  },
  {
    title: "Company",
    links: [
      { href: "/about", label: "About" },
      { href: "/contact", label: "Contact" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-ink-900 text-ink-300">
      <div className="mx-auto max-w-7xl px-6 py-20">
        <div className="grid grid-cols-2 gap-12 md:grid-cols-4 lg:grid-cols-5">
          <div className="col-span-2 md:col-span-4 lg:col-span-1 mb-10 lg:mb-0">
            <Link href="/" className="flex items-center gap-2 group mb-6">
              <div className="w-8 h-8 bg-brand-600 rounded-lg flex items-center justify-center text-white shadow-lg shadow-brand-900 group-hover:rotate-12 transition-transform">
                <Zap className="w-5 h-5 fill-white" />
              </div>
              <span className="text-xl font-black tracking-tight text-white">
                OneTap<span className="text-brand-500">Reply</span>
              </span>
            </Link>
            <p className="text-sm text-ink-400 max-w-xs leading-relaxed mb-8">
              Empowering local businesses to manage their online reputation effortlessly with AI. 
              Built for speed, simplicity, and results.
            </p>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <h3 className="text-sm font-bold text-white uppercase tracking-wider mb-6">{col.title}</h3>
              <ul className="space-y-4">
                {col.links.map((l) => (
                  <li key={l.href}>
                    <Link href={l.href} className="text-sm text-ink-400 hover:text-brand-400 transition-colors">
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-20 pt-10 border-t border-ink-800 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="text-sm text-ink-500 flex flex-col items-center md:items-start gap-1">
            <p>&copy; {new Date().getFullYear()} OneTapReply. All rights reserved.</p>
            <p className="text-xs text-ink-400 leading-relaxed">
              OneTapReply is a product of <a href="https://lovemath.co" className="underline hover:text-ink-300">Lovemath LLC</a><br />
              45 Warwick Rd, Princeton Junction, NJ 08550
            </p>
          </div>
          <div className="flex items-center gap-2 text-sm text-ink-500">
            Made with <Heart className="w-4 h-4 text-sig-red fill-sig-red" /> for local businesses.
          </div>
          <div className="flex gap-8">
             <Link href="/legal/privacy" className="text-xs text-ink-600 hover:text-ink-400">Privacy</Link>
             <Link href="/legal/terms" className="text-xs text-ink-600 hover:text-ink-400">Terms</Link>
             <Link href="/sitemap.xml" className="text-xs text-ink-600 hover:text-ink-400">Sitemap</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
